import axios from 'axios';
import qs from 'qs';

axios.interceptors.request.use(config => {
        config.baseURL = "http://telaote.weilomo.com/";
        return config;
    },
    err => {
        return Promise.reject(err);
    },
);

axios.interceptors.response.use(response => {
    return response;
}, err => {
    if (err.response) {
        switch (err.response.status) {
            case 401:
                break;
            case 404:
                break;
            default:
                break;
        }
    }
    return Promise.reject(err.response);
});

const fetch = async (url = '', params = {}, method = 'post') => {
    return axios.post(url,params,{
        transformRequest : [
            (data) => {
                return qs.stringify(data)
            }
        ]
    }).then(response => response.data).then((json) => {
        if(json.status == 1){
            return json.data;
        }else {
            let errcode = json.errcode || 0
            switch(errcode) {
                case 301:
                    break;
                case 404:
                    break;
                default:
                    break;
            }
            return false;
        }
    });
};



const clientsList = () => {
    return fetch('Admin/Api/clientslist')
};

const memeberList = () => {
    return fetch('Admin/Api/membersarea')
};

const insighList = () => {
    return fetch('Admin/Api/insightlist')
};

const newsList = () => {
    return fetch('Admin/Api/newsList')
};

const newsDetails = (id) => {
    return fetch('Admin/Api/newsdetail?id='+id,{id})
};

const insightdetail = (id) => {
    return fetch('Admin/Api/insightdetail?id='+id,{id})
};

const aboutIndex = () => {
    return fetch('Admin/Api/aboutuslist')
};

const conceptsList = () => {
    return fetch('Admin/Api/conceptslist')
};

const historyList = () => {
    return fetch('Admin/Api/historylist')
};

const consultingList = () => {
    return fetch('Admin/Api/consultinglist')
};

const contactusarea = () => {
    return fetch('Admin/Api/contactusarea')
};

//抛出数据
export default {
    clientsList,
    memeberList,
    insighList,
    newsList,
    newsDetails,
    insightdetail,
    aboutIndex,
    conceptsList,
    historyList,
    consultingList,
    contactusarea
}
